export default __webpack_public_path__ + "static/img/Group 19@3 1.0065334.png";